<template>
  <section class="content">
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" v-if="me.rname === 'ROLE_PLATFORM' || me.rname === 'ROLE_ADMIN' || me.rname === 'ROLE_DEMO'">
      <el-form :inline="true" :model="filters">
        <el-form-item label="客户名称:">
          <el-select v-model="filters.company" filterable placeholder="请选择" @change="companyChange">
            <el-option
                    v-for="item in companies"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col :span="24">
      <h2><span class="company">{{selectedCompany.name}}</span>诊断分析报告</h2>
      <p style="text-align:center;">{{timeRangeStart | filterDate}} ~ {{timeRangeEnd | filterDate}}</p>
    </el-col>
    <el-col :span="24">
      <h3>一、设备状况</h3>
      <!--<p><span class="company">{{selectedCompany.name}}</span>用电安全监测情况分析: <span v-if="devices">{{devices.length}}个监测设备,</span>{{warnNum}}个预警设备, {{errorNum}}个告警设备, {{faultNum}}个故障设备。</p>-->
    </el-col>
    <el-table :data="devices" border highlight-current-row v-loading="listLoading"
              style="width: 100%;">
      <el-table-column header-align="center" prop="name" label="监控站点" min-width="160">
      </el-table-column>
      <el-table-column header-align="center" align="center" label="线缆电流"
                       width="100">
        <template scope="scope">
          <el-tooltip effect="dark" placement="right" :enterable="false">
            <div slot="content" v-html="$options.filters.filterTips(scope.row, 1)"></div>
            <div v-html="$options.filters.filterState(scope.row, 1)"></div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="线缆温度"
                       width="100">
        <template scope="scope">
          <el-tooltip effect="dark" placement="right" :enterable="false">
            <div slot="content" v-html="$options.filters.filterTips(scope.row, 2)"></div>
            <div v-html="$options.filters.filterState(scope.row, 2)"></div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="零线电流"
                       width="100">
        <template scope="scope">
          <el-tooltip effect="dark" placement="right" :enterable="false">
            <div slot="content" v-html="$options.filters.filterTips(scope.row, 3)"></div>
            <div v-html="$options.filters.filterState(scope.row, 3)"></div>
          </el-tooltip>
        </template>
      </el-table-column>
      <!--<el-table-column header-align="center" align="center" label="漏电电流"-->
      <!--width="100">-->
      <!--<template scope="scope">-->
      <!--0-->
      <!--</template>-->
      <!--</el-table-column>-->
      <el-table-column header-align="center" align="center" label="谐波含量"
                       width="100">
        <template scope="scope">
          <el-tooltip effect="dark" placement="right" :enterable="false">
            <div slot="content" v-html="$options.filters.filterTips(scope.row, 4)"></div>
            <div v-html="$options.filters.filterState(scope.row, 4)"></div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="功率因素"
                       width="100">
        <template scope="scope">
          <el-tooltip effect="dark" placement="right" :enterable="false">
            <div slot="content" v-html="$options.filters.filterTips(scope.row, 5)"></div>
            <div v-html="$options.filters.filterState(scope.row, 5)"></div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="三相不平衡"
                       width="120">
        <template scope="scope">
          <el-tooltip effect="dark" placement="right" :enterable="false">
            <div slot="content" v-html="$options.filters.filterTips(scope.row, 6)"></div>
            <div v-html="$options.filters.filterState(scope.row, 6)"></div>
          </el-tooltip>
        </template>
      </el-table-column>
      <!--<el-table-column header-align="center" align="center" label="电压合格率"-->
      <!--width="120">-->
      <!--<template scope="scope">-->
      <!--0-->
      <!--</template>-->
      <!--</el-table-column>-->
      <el-table-column header-align="center" align="center" label="电流失真度"
                       width="120">
        <template scope="scope">
          <el-tooltip effect="dark" placement="right" :enterable="false">
            <div slot="content" v-html="$options.filters.filterTips(scope.row, 7)"></div>
            <div v-html="$options.filters.filterState(scope.row, 7)"></div>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total"
                     style="float:right;">
      </el-pagination>
    </el-col>

    <el-table :data="devices3" border highlight-current-row v-loading="listLoading2"
              style="width: 100%;" v-if="devices3.length > 0">
      <el-table-column header-align="center" prop="name" label="监控站点" width="400">
      </el-table-column>
      <el-table-column header-align="center" align="center" label="剩余电流"
                       min-width="100">
        <template scope="scope">
          <!--<el-tooltip effect="dark" placement="right" :enterable="false">-->
            <!--&lt;!&ndash;<div slot="content" v-html="$options.filters.filterTips2(scope.row, 1)"></div>&ndash;&gt;-->
            <!--<div v-html="$options.filters.filterState2(scope.row, 1)"></div>-->
          <!--</el-tooltip>-->
          <div v-html="$options.filters.filterState2(scope.row, 1)"></div>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="温度"
                       min-width="100">
        <template scope="scope">
          <!--<el-tooltip effect="dark" placement="right" :enterable="false">-->
            <!--&lt;!&ndash;<div slot="content" v-html="$options.filters.filterTips2(scope.row, 2)"></div>&ndash;&gt;-->
            <!--<div v-html="$options.filters.filterState2(scope.row, 2)"></div>-->
          <!--</el-tooltip>-->
          <div v-html="$options.filters.filterState2(scope.row, 2)"></div>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar" v-if="devices3.length > 0">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange2" :page-size="10" :total="total2"
                     style="float:right;">
      </el-pagination>
    </el-col>

    <el-col :span="24" style="margin-bottom: 20px;">
      <h3>二、特征分析</h3>
      <!--工具条-->
      <el-col :span="24" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="filters">
          <el-col>
            <el-form-item label="区域:">
              <el-select v-model="filters.groupId" placeholder="请选择" @change="groupChange">
                <el-option
                        v-for="item in groups" :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备名称:" >
              <el-select v-model="filters.deviceId" placeholder="请选择" @change="deviceChange">
                <el-option
                        v-for="item in devices2"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
      </el-col>
      <el-card class="box-card">
        <div id="dianliuChart" class="chart1"></div>
        <!--<p style="text-align:center;">特征分析一: 在监测周期内, 1层大屏幕配电箱监测零线电流均值为23.5A, 峰值为59.7A (58.7A > 额定电流50A), 处于告警状态。</p>-->
      </el-card>

      <el-card class="box-card" style="margin-top: 50px;">
        <div id="wenduChart" class="chart1"></div>
        <!--<p style="text-align:center;">特征分析一: 在监测周期内, 1层大屏幕配电箱监测零线电流均值为23.5A, 峰值为59.7A (58.7A > 额定电流50A), 处于告警状态。</p>-->
      </el-card>
    </el-col>
    <!--<el-col :span="24">-->
      <!--<h3>三、隐患危害</h3>-->
      <!--<p>漏电现象与危害。</p>-->
      <!--<p>所谓漏电, 就是线路的某一个地方因为某种原因(如风吹雨打、潮湿、高温、碰压、划破、摩擦、腐蚀等)使电线的绝缘或支架材料的绝缘能力下降,导致电线与电线之间, 导线与大地之间有一部分电流通过。</p>-->
    <!--</el-col>-->
    <!--<el-col :span="24">-->
      <!--<h3>四、排查及建议</h3>-->
      <!--<p>中国消防博物馆 用电安全监测情况分析: 监测区域: 4个, 4个异常预警, 11个告警。</p>-->
    <!--</el-col>-->
  </section>
</template>
<style>
  .content {
    padding-left: 100px;
    padding-right: 100px;
  }

  .company {
    color: #007ebf;
  }

  .circle_normal:before {
    content: ' \25CF';
    font-size: 30px;
    color: #00ff00;
  }

  .circle_warn:before {
    content: ' \25CF';
    font-size: 30px;
    color: #ffff00;
  }

  .circle_error:before {
    content: ' \25CF';
    font-size: 30px;
    color: #ff0000;
  }

  .circle_gray:before {
    content: ' \25CF';
    font-size: 30px;
    color: #999999;
  }

  .chart1 {
    width: 100% !important;
    height: 400px !important;
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    box-sizing: border-box;
  }

  .echarts {
    width: 100% !important;
    height: 400px !important;
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    box-sizing: border-box;
  }

  h2 {
    text-align: center;
  }
</style>
<script>
  import moment from 'moment'
  import async from 'async'
  import echarts from 'echarts'
  import {getCompanyList, getDevicesList, getReportList,getGroupList,getDevicesByGroupList, getWeekDataList, getCompanyGroupByCity} from '../../api/api';

  export default{
    data(){
      return {
        me: JSON.parse(sessionStorage.getItem('user')),
        companies: [],
        selectedCompany: {},
        groups: [],
        devices: [],
        dianliuWeekDatas: [],
        wenduWeekDatas: [],
        devices2: [],
        devices3: [],
        filters: {
          company: {},
          groupId: '',
          deviceId: '',
        },
        page: 1,
        page2: 1,
        total: 0,
        total2: 0,
        warnNum: 0,
        errorNum: 0,
        faultNum: 0,
        dianliuChart: {},
        wenduChart: {},
        listLoading: false,
        listLoading2: false,
        timeRangeStart: moment().startOf('isoweek').hours(0).minutes(0).seconds(0).valueOf(),
        timeRangeEnd: moment().startOf('isoweek').add(8, 'days').hours(0).minutes(0).seconds(0).valueOf(),
      }
    },
    filters: {
      filterDate(date) {
        if (date)
          return moment(date).format('YYYY-MM-DD');
      },
      filterTips(row, type) {
        var data = row.exceptions;
        if (!data) {
          return;
        }

        if (row.deviceId.toUpperCase().startsWith("9")) {
          return '无';
        }

        var html = '';
        for (var k = 0; k< data.length; k++) {
          var d = data[k];
          if (type == 1) {
            switch(d.paramsType) {
              case 12:
                html += d.type == 2 ? 'A相电流预警<br/>' : 'A相电流告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 13:
                html += d.type == 2 ? 'B相电流预警<br/>' : 'B相电流告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 14:
                html += d.type == 2 ? 'C相电流预警<br/>' : 'C相电流告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
            }
          } else if (type == 2) {
            switch(d.paramsType) {
              case 5:
                html += d.type == 2 ? '第1路温度预警<br/>' : '第1路温度告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 6:
                html += d.type == 2 ? '第2路温度预警<br/>' : '第2路温度告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 7:
                html += d.type == 2 ? '第3路温度预警<br/>' : '第3路温度告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 8:
                html += d.type == 2 ? '第4路温度预警<br/>' : '第4路温度告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
            }
          } else if (type == 3) {
            switch(d.paramsType) {
              case 15:
                html += d.type == 2 ? '零线电流预警<br/>' : '零线电流告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
            }
          } else if (type == 4) {
            switch(d.paramsType) {
              case 38:
                html += d.type == 2 ? 'A相电压3次谐波含量预警<br/>' : 'A相电压3次谐波含量告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 39:
                html += d.type == 2 ? 'B相电压3次谐波含量预警<br/>' : 'B相电压3次谐波含量告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 40:
                html += d.type == 2 ? 'C相电压3次谐波含量预警<br/>' : 'C相电压3次谐波含量告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 41:
                html += d.type == 2 ? 'A相电压5次谐波含量预警<br/>' : 'A相电压5次谐波含量告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 42:
                html += d.type == 2 ? 'B相电压5次谐波含量预警<br/>' : 'B相电压5次谐波含量告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 43:
                html += d.type == 2 ? 'C相电压5次谐波含量预警<br/>' : 'C相电压5次谐波含量告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 44:
                html += d.type == 2 ? 'A相电压7次谐波含量预警<br/>' : 'A相电压7次谐波含量告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 45:
                html += d.type == 2 ? 'B相电压7次谐波含量预警<br/>' : 'B相电压7次谐波含量告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 46:
                html += d.type == 2 ? 'C相电压7次谐波含量预警<br/>' : 'C相电压7次谐波含量告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 47:
                html += d.type == 2 ? 'A相电压9次谐波含量预警<br/>' : 'A相电压9次谐波含量告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 48:
                html += d.type == 2 ? 'B相电压9次谐波含量预警<br/>' : 'B相电压9次谐波含量告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 49:
                html += d.type == 2 ? 'C相电压9次谐波含量预警<br/>' : 'C相电压9次谐波含量告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 50:
                html += d.type == 2 ? 'A相电压11次谐波含量预警<br/>' : 'A相电压11次谐波含量告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 51:
                html += d.type == 2 ? 'B相电压11次谐波含量预警<br/>' : 'B相电压11次谐波含量告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 52:
                html += d.type == 2 ? 'C相电压11次谐波含量预警<br/>' : 'C相电压11次谐波含量告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
            }
          } else if (type == 5) {
            switch(d.paramsType) {
              case 20:
                html += d.type == 2 ? 'A相功率因素预警<br/>' : 'A相功率因素告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 21:
                html += d.type == 2 ? 'B相功率因素预警<br/>' : 'B相功率因素告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 22:
                html += d.type == 2 ? 'C相功率因素预警<br/>' : 'C相功率因素告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 23:
                html += d.type == 2 ? '总功率因素预警<br/>' : '总功率因素告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
            }
          } else if (type == 6) {
            switch(d.paramsType) {
              case 24:
                html += d.type == 2 ? '电压不平衡度预警<br/>' : '电压不平衡度告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 25:
                html += d.type == 2 ? '电流不平衡度预警<br/>' : '电流不平衡度告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
            }
          } else if (type == 7) {
            switch(d.paramsType) {
              case 29:
                html += d.type == 2 ? 'A相电流波形失真预警<br/>' : 'A相电流波形失真告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 30:
                html += d.type == 2 ? 'B相电流波形失真预警<br/>' : 'B相电流波形失真告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
              case 31:
                html += d.type == 2 ? 'C相电流波形失真预警<br/>' : 'C相电流波形失真告警';
                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/><br/>';
                break;
            }
          }
        }
        if (html == '') {
          html = '状态正常';
        } else {
          html = html.substring(0, html.length - 5);
        }

        return html;
      },
//      filterTips2(row, type) {
//        if (!row) {
//          return;
//        }
//
//        var html = '';
//
//        if (row.state == 4) {
//          html += d.type == 1 ? '剩余电流预警<br/>' : '剩余电流告警';
//          html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/>';
//        } else if (row.state == 3) {
//          return '<span class="circle_error"></span>';
//        } else if (row.state == 2) {
//          return '<span class="circle_warn"></span>';
//        } else if (row.state == 1) {
//          return '<span class="circle_normal"></span>';
//        }
//
//        for (var k = 0; k< data.length; k++) {
//          var d = data[k];
//          if (type == 1) {
//            switch(d.paramsType) {
//              case 101:
//              case 102:
//              case 103:
//              case 104:
//              case 105:
//              case 106:
//              case 107:
//              case 108:
//                html += d.type == 2 ? '剩余电流预警<br/>' : '剩余电流告警';
//                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/>';
//                break;
//              case 201:
//              case 202:
//              case 203:
//              case 204:
//              case 205:
//              case 206:
//              case 207:
//              case 208:
//                html += d.type == 2 ? '温度预警<br/>' : '温度告警';
//                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/>';
//                break;
//            }
//          } else if (type == 2) {
//            switch(d.paramsType) {
//              case 101:
//              case 102:
//              case 103:
//              case 104:
//              case 105:
//              case 106:
//              case 107:
//              case 108:
//                html += d.type == 2 ? '剩余电流预警<br/>' : '剩余电流告警';
//                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/>';
//                break;
//              case 201:
//              case 202:
//              case 203:
//              case 204:
//              case 205:
//              case 206:
//              case 207:
//              case 208:
//                html += d.type == 2 ? '温度预警<br/>' : '温度告警';
//                html += ' ' + moment(d.createdAt).format('YYYY-MM-DD HH:mm:ss') + '<br/>';
//                break;
//            }
//          }
//        }
//        if (html == '') {
//          html = '状态正常';
//        }
//        return html;
//      },
      filterState(row, type) {
        var data = row.exceptions;
        if (!data) {
          return;
        }

        if (row.deviceId.toUpperCase().startsWith("9")) {
          return '-';
        }

        var t = {};
        t.xldl_w = 0;
        t.xldl_e = 0;
        t.xlwd_w = 0;
        t.xlwd_e = 0;
        t.lxdl_w = 0;
        t.lxdl_e = 0;
        t.xbhl_w = 0;
        t.xbhl_e = 0;
        t.glys_w = 0;
        t.glys_e = 0;
        t.sxbph_w = 0;
        t.sxbph_e = 0;
        t.dlszd_w = 0;
        t.dlszd_e = 0;
        for (var k = 0; k< data.length; k++) {
          var d = data[k];
          if (d.paramsType == 12 || d.paramsType == 13 || d.paramsType == 14) {
            if (d.type == 2) {
              t.xldl_w += 1;
            } else if (d.type == 3) {
              t.xldl_e += 1;
            }
          } else if (d.paramsType == 5 || d.paramsType == 6 || d.paramsType == 7 || d.paramsType == 8) {
            if (d.type == 2) {
              t.xlwd_w += 1;
            } else if (d.type == 3) {
              t.xlwd_e += 1;
            }
          } else if (d.paramsType == 15) {
            if (d.type == 2) {
              t.lxdl_w += 1;
            } else if (d.type == 3) {
              t.lxdl_e += 1;
            }
          } else if (d.paramsType >= 32 && d.paramsType <= 46) {
            if (d.type == 2) {
              t.xbhl_w += 1;
            } else if (d.type == 3) {
              t.xbhl_e += 1;
            }
          } else if (d.paramsType >= 20 && d.paramsType <= 23) {
            if (d.type == 2) {
              t.glys_w += 1;
            } else if (d.type == 3) {
              t.glys_e += 1;
            }
          } else if (d.paramsType == 24 || d.paramsType == 25) {
            if (d.type == 2) {
              t.sxbph_w += 1;
            } else if (d.type == 3) {
              t.sxbph_e += 1;
            }
          } else if (d.paramsType == 29 || d.paramsType == 30 || d.paramsType == 31) {
            if (d.type == 2) {
              t.dlszd_w += 1;
            } else if (d.type == 3) {
              t.dlszd_e += 1;
            }
          }
        }

        if ((type == 1 && t.xldl_e > 0) || (type == 2 && t.xlwd_e > 0) || (type == 3 && t.lxdl_e > 0) || (type == 4 && t.xbhl_e > 0) || (type == 5 && t.glys_e > 0) || (type == 6 && t.sxbph_e > 0) || (type == 7 && t.dlszd_e > 0)) {
          return '<span class="circle_error"></span>';
        } else if ((type == 1 && t.xldl_w > 0) || (type == 2 && t.xlwd_w > 0) || (type == 3 && t.lxdl_w > 0) || (type == 4 && t.xbhl_w > 0) || (type == 5 && t.glys_w > 0) || (type == 6 && t.sxbph_w > 0) || (type == 7 && t.dlszd_w > 0)) {
          return '<span class="circle_warn"></span>';
        } else if ((type == 1 && t.xldl_e == 0 && t.xldl_w == 0) || (type == 2 && t.xlwd_e == 0 && t.xlwd_w == 0) || (type == 3 && t.lxdl_e == 0 && t.lxdl_w == 0) || (type == 4 && t.xbhl_e == 0 && t.xbhl_w == 0) || (type == 5 && t.glys_e == 0 && t.glys_w == 0) || (type == 6 && t.sxbph_e == 0 && t.sxbph_w == 0) || (type == 7 && t.dlszd_e == 0 && t.dlszd_w == 0)) {
          return '<span class="circle_normal"></span>';
        }

      },
      filterState2(row, type) {
        if (!row) {
          return;
        }

        if (row.state == 4) {
          return '<span class="circle_gray"></span>';
        } else if (row.state == 3) {
          this.errorNum++;
          return '<span class="circle_error"></span>';
        } else if (row.state == 2) {
          return '<span class="circle_warn"></span>';
        } else if (row.state == 1) {
          return '<span class="circle_normal"></span>';
        }

      }
    },
    methods: {
      //获取企业列表
      getCompanies() {
        let para = {
          name: ''
        };
        //NProgress.start();
        getCompanyList(para).then((res) => {
          this.companies = res.data.list;
          this.filters.company = this.companies[0].id;
          //NProgress.done();
//          this.getDevices();
        });
      },
      getWeekData(id, type) {
        let para = {
          deviceId: id,
          type: type,
          timeRangeStart: this.timeRangeStart,
          timeRangeEnd: this.timeRangeEnd,
        };
        //NProgress.start();
        getWeekDataList(para).then((res) => {
          if (type == 1) {
            this.dianliuWeekDatas = res.data;

            var options = {
              title: {
                text: '电流分析',
                        left: 'center',
                        textStyle: {
                  fontSize: 18,
                          color: '#444444'
                }
              },
              tooltip: {
                trigger: 'axis'
              },
              legend: {
                top: '10%',
                        data: ['A相电流', 'B相电流', 'C相电流', '零线电流']
              },
              grid: {
                left: '3%',
                        right: '4%',
                        top: '28%',
                        containLabel: true
              },
              xAxis: {
                type: 'category',
                        boundaryGap: false,
                        data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
              },
              yAxis: {
                type: 'value'
              },
              series: []
            };

            var valueA = this.dianliuWeekDatas.map(el => {
              if (el.des == "A相电流")
                return el;
            }).filter(t => {return t});

            var valueB = this.dianliuWeekDatas.map(el => {
              if (el.des == "B相电流")
                return el;
            }).filter(t => {return t});

            var valueC = this.dianliuWeekDatas.map(el => {
              if (el.des == "C相电流")
                return el;
            }).filter(t => {return t});

            var value0 = this.dianliuWeekDatas.map(el => {
              if (el.des == "零线电流")
                return el;
            }).filter(t => {return t});

            var time = valueA.map(t => {return moment(t.createdAt).utc().format('HH:mm:ss')}).reverse();

            var serA = {
              name: 'A相电流',
              type: 'line',
              smooth:true,
              data: valueA.map(t => {return t.value}).reverse()
            };
            var serB = {
              name: 'B相电流',
              type: 'line',
              smooth:true,
              data: valueB.map(t => {return t.value}).reverse()
            };
            var serC = {
              name: 'C相电流',
              type: 'line',
              smooth:true,
              data: valueC.map(t => {return t.value}).reverse()
            };
            var ser0 = {
              name: '零线电流',
              type: 'line',
              smooth:true,
              data: value0.map(t => {return t.value}).reverse()
            };
            options.series = [serA, serB, serC, ser0];
            options.xAxis.data = time;
            this.dianliuChart.setOption(options);

            this.dianliuChart.on('legendselectchanged', function (params) {
              if (params.name == 'A相电流')
                time = valueA.map(t => {return moment(t.createdAt).format('HH:mm:ss')}).reverse();
              else if (params.name == 'B相电流')
                time = valueB.map(t => {return moment(t.createdAt).format('HH:mm:ss')}).reverse();
              else if (params.name == 'C相电流')
                time = valueC.map(t => {return moment(t.createdAt).format('HH:mm:ss')}).reverse();
              else if (params.name == '零线电流')
                time = value0.map(t => {return moment(t.createdAt).format('HH:mm:ss')}).reverse();
            });
          } else {
            this.wenduWeekDatas = res.data;

            var options = {
              title: {
                text: '温度分析',
                left: 'center',
                textStyle: {
                  fontSize: 18,
                  color: '#444444'
                }
              },
              tooltip: {
                trigger: 'axis'
              },
              legend: {
//                selectedMode: 'single',
//                selected: {
//                  '第1路温度': true,
//                  '第2路温度': false,
//                  '第3路温度': false,
//                  '第4路温度': false,
//                },
                top: '10%',
                data: ['第1路温度', '第2路温度', '第3路温度', '第4路温度']
              },
              grid: {
                left: '3%',
                right: '4%',
                top: '28%',
                containLabel: true
              },
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
              },
              yAxis: {
                type: 'value'
              },
              series: []
            };

            var value1 = this.wenduWeekDatas.map(el => {
              if (el.des == "第1路温度")
                return el;
            }).filter(t => {return t});

            var value2 = this.wenduWeekDatas.map(el => {
              if (el.des == "第2路温度")
                return el;
            }).filter(t => {return t});

            var value3 = this.wenduWeekDatas.map(el => {
              if (el.des == "第3路温度")
                return el;
            }).filter(t => {return t});

            var value4 = this.wenduWeekDatas.map(el => {
              if (el.des == "第4路温度")
                return el;
            }).filter(t => {return t});

            var time = value1.map(t => {return moment(t.createdAt).utc().format('HH:mm:ss')}).reverse();

            var ser1 = {
              name: '第1路温度',
              type: 'line',
              smooth:true,
              data: value1.map(t => {return t.value}).reverse()
            };
            var ser2 = {
              name: '第2路温度',
              type: 'line',
              smooth:true,
              data: value2.map(t => {return t.value}).reverse()
            };
            var ser3 = {
              name: '第3路温度',
              type: 'line',
              smooth:true,
              data: value3.map(t => {return t.value}).reverse()
            };
            var ser4 = {
              name: '第4路温度',
              type: 'line',
              smooth:true,
              data: value4.map(t => {return t.value}).reverse()
            };
            options.series = [ser1, ser2, ser3, ser4];
            options.xAxis.data = time;
            this.wenduChart.setOption(options);

            this.wenduChart.on('legendselectchanged', function (params) {
              if (params.name == '第1路温度')
                time = value1.map(t => {return moment(t.createdAt).format('HH:mm:ss')}).reverse();
              else if (params.name == '第2路温度')
                time = value2.map(t => {return moment(t.createdAt).format('HH:mm:ss')}).reverse();
              else if (params.name == '第3路温度')
                time = value3.map(t => {return moment(t.createdAt).format('HH:mm:ss')}).reverse();
              else if (params.name == '第4路温度')
                time = value4.map(t => {return moment(t.createdAt).format('HH:mm:ss')}).reverse();
            });
          }
        });
      },
      //获取企业列表
      getGroups(company) {
        let para = {
          companyId: company
        };
        //NProgress.start();
        getGroupList(para).then((res) => {
          this.groups = res.data.list;

          if (this.groups.length == 0) {
            this.getDevicesByGroup('');
          } else {
            this.filters.groupId = this.groups[0].id;
            this.getDevicesByGroup(this.groups[0].id);
          }
        });
      },
      handleCurrentChange(val) {
        this.page = val;
        this.getDevices();
      },
      handleCurrentChange2(val) {
        this.page2 = val;
        this.getDevices3();
      },
      getDevicesByGroup(val) {
        let para = {
          groupId: val
        };
        //NProgress.start();
        getDevicesByGroupList(para).then((res) => {
          this.devices2 = res.data.filter(t => !t.deviceId.toUpperCase().startsWith("9"));
          if (this.devices2.length > 0) {
            this.filters.deviceId = this.devices2[0].id;
          }
          //NProgress.done();
        });
      },
      getDevices3() {
        let para = {
          page: this.page2,
          size: 10,
          name: this.selectedCompany.name,
        };
        this.listLoading2 = true;
        //NProgress.start();
        getDevicesList(para).then((res) => {
          this.total2 = res.data.total;
          this.devices3 = res.data.list.filter(t => t.deviceId.toUpperCase().startsWith("9"));
          this.listLoading2 = false;
        });

      },
      getDevices() {
        this.warnNum = 0;
        this.faultNum = 0;
        let para = {
          page: this.page,
          size: 10,
          name: this.selectedCompany.name,
        };
        this.listLoading = true;
        //NProgress.start();
        getDevicesList(para).then((res) => {
          this.total = res.data.total;
          this.devices = res.data.list.filter(t => !t.deviceId.toUpperCase().startsWith("9"));
          this.devices3 = res.data.list.filter(t => t.deviceId.toUpperCase().startsWith("9"));

          res.data.list.forEach(t => {
            if (t.state == 2) {
              this.warnNum++;
            } else if (t.state == 3) {
              this.errorNum++;
            } else if (t.state == 4) {
              this.faultNum++;
            }
          })

          if (this.devices) {
            async.map(this.devices, (t, done) => {
              getReportList({
                deviceId: t.id,
                timeRangeStart: this.timeRangeStart,
                timeRangeEnd: this.timeRangeEnd,
              }).then((res) => {
                t.exceptions = res.data.list;
                t.tips_xldl = '';
//                t.exceptions.forEach(d => {
//                  if (d.type == 2) {
//                    this.warnNum++;
//                  } else if (d.type == 3) {
//                    this.errorNum++;
//                  }
//                });
                done(null, t);
              })
            }, (err, results) => {
              this.devices = results;
              return results;
            });
          }
          this.listLoading = false;
          //NProgress.done();
        });
      },
      companyChange: function (val) {
        this.selectedCompany = this.companies.filter(t => {
          return t.id == val
        })[0];
        this.filters.groupId = '';
        this.getDevices();
        this.getGroups(val);
        this.initChart();
      },
      groupChange: function (val) {
        this.filters.deviceId = '';
        this.getDevicesByGroup(val);
      },
      deviceChange: function (val) {
        if (!!val) {
          this.getWeekData(val, 1);
          this.getWeekData(val, 2);
        }
      },
      initChart() {
        this.dianliuChart = echarts.init(document.getElementById('dianliuChart'));
        this.wenduChart = echarts.init(document.getElementById('wenduChart'));
      }
    },
    mounted() {
      if (this.me.rname === 'ROLE_PLATFORM' || this.me.rname === 'ROLE_ADMIN' || this.me.rname === 'ROLE_DEMO') {
        this.getCompanies();
      } else {
        this.filters.company.id = this.me.companyId;
        this.selectedCompany.name = this.me.company;
        this.getGroups(this.me.companyId);
        this.getDevices();
        this.getDevices3();
        this.initChart();
      }
    },
    components: {}
  }
</script>



// WEBPACK FOOTER //
// Report.vue?5be5de78